const { normaliseKey } = require('./key-utils');

/**
 * Convert a Falcor array syntax path into a string path. Only suitable for leaf paths,
 * not query or routing expressions
 * @param {LeafPath<Array>} pathSetExpression the array syntax path expression to convert
 * @returns {LeafPath<string>} the converted string path
 * @example
 * join(['fx', 'pairs', 0, 'bid']);
 * // => 'fx.pairs[0].bid'
 * @example
 * join(['usersById', 'first.last@db.com']);
 * // => 'usersById["first.last@db.com"]'
 */
function join(pathSetExpression = []) {
  return pathSetExpression
    .map(normaliseKey)
    .join('.')
    .replace(/\.\[/g, '[');
}

module.exports = join;
